import React from 'react'
import '../AppleLoginButton/AppleLoginButton.scss'

class AppleSignupButton extends React.Component {
  render() {
    return (
      <a
        href="/apple_signup"
        className="login-btn-apple"
        id="appleid-signin"
        data-text={this.props.children}
      />
    )
  }
}

export { AppleSignupButton }
